import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Users Access',
  basePath: '/users-access',
  columns: [
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'user_name', label: 'User', sortable: true },
    { key: 'menu_title', label: 'Menu Item', sortable: true },
    { key: 'privileges', label: 'Privileges' },
  ],
  fields: [
    { key: 'user_id', label: 'User', type: 'async-select',
      optionsUrl: '/users-admin/options', required: true },
    { key: 'country', label: 'Country', type: 'async-select',
      optionsUrl: '/countries/options',
      dependsOn: ['user_id'] },
    { key: 'menu_id', label: 'Menu item', type: 'async-select',
      optionsUrl: '/menu/options',
      dependsOn: ['country', 'user_id'],
      valuesParams: { country: 'country', user_id: 'user_id' },
      visible: (v) => !!v.country },
    { key: 'privileges', label: 'Privileges', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/privileges/options' },
  ],
  defaultSort: { field: 'user_name', dir: 'asc' },
});
